import React  from 'react';

const Header = () => {
    return (
        <section>
            <div className="text-center">
                <img className='login-img' src={`${process.env.PUBLIC_URL}/logo-2.jpg`} alt="Technext" />
                <h4>Controle de Acesso</h4>
            </div>
        </section>
    );
};

export default Header;